import { Controller } from "@hotwired/stimulus"

// Submits the form it is attached to, e.g. when a sort select changes.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
